<div class="row content-cards" *ngIf="!esHW">
	<div class="col-lg-6 col-xl-3 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarVehiculo]">
		<mat-card style="background-color: #3da73d; cursor: pointer;" (click)="irMonitoreo('verde')">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-car-side fa-2x" style="color: #3da73d;"></i></div>
				<mat-card-title>Vehículos en Movimiento</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{vehiculosEnMovimiento}} <br>
						<small class="arial">Vehículos</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-car fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="col-lg-6 col-xl-3 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarVehiculo]">
		<mat-card style="background-color: #ff8101; cursor: pointer;" (click)="irAdministracionVehiculos()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-car fa-2x" style="color: #ff8101;"></i></div>
				<mat-card-title>Total de Vehículos</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{totalVehiculos}}<br>
						<small class="arial">Vehículos</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-car-bus fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="col-lg-6 col-xl-3 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoAlertaSalidaGeocerca]">
		<mat-card style="background-color: #800180; cursor: pointer;" (click)="alertasHeader()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-map-marker-exclamation fa-2x" style="color: #90458f;"></i></div>
				<mat-card-title>Salidas de Geocerca</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{vehiculosFueraGeocerca}}<br>
						<small class="arial">Vehículos</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-draw-polygon fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="col-lg-6 col-xl-3 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarVehiculo]">
		<mat-card style="background-color: #f9c301; cursor: pointer;" (click)="irAdministracionConsola()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-exclamation-triangle fa-2x" style="color: #ffc107ad;"></i></div>
				<mat-card-title>&nbsp;Vehículos Alertados</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{totalAlertados}}<br>
						<small class="arial">Alertados</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-engine-warning fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
		<div class="col-lg-6 col-xl-3 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngIf="user.saldo != '0' " >
		<mat-card style="background-color: #f9c301; cursor: pointer;">
			<mat-card-header>
				<div mat-card-avatar><i class="fas fa-wallet  fa-2x" style="color: #ffc107ad;"></i></div>
				<mat-card-title>&nbsp;Saldo Total</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						<h1 class="saldo">$ {{saldo}}</h1><br>
					</div>
					<div class="col-md-6">
						<i class="fas fa-coins fa-7x icon dolar"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>

</div>


	<div class="col-lg-12 col-xl-6 col-sm-12 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarSemaforo]">
		<mat-card class="card_graphic" style="background-color: white;">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-file-chart-pie fa-2x" style="color: #46be8a;"></i></div>
				<mat-card-title>Estado de Movimiento</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<dx-pie-chart (onPointClick)="semaforo($event)"  type="doughnut" palette="Soft Pastel" [dataSource]="datosPastel"
					[customizePoint]="customizePoint">
					<dxi-series argumentField="etiqueta">
						<dxo-label [visible]="true" [customizeText]="etiquetaPie">
							<dxo-connector [visible]="true"></dxo-connector>
						</dxo-label>
					</dxi-series>
					<dxo-legend [margin]="0" horizontalAlignment="right" verticalAlignment="top"></dxo-legend>
					<dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip">
					</dxo-tooltip>
				</dx-pie-chart>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="col-lg-12 col-xl-6 col-sm-12 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoMostrarAlertasMDVR]">
		<mat-card class="card_graphic" style="background-color: white;">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-file-chart-pie fa-2x" style="color: #46be8a;"></i></div>
				<mat-card-title>Alertas Reportadas</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-12">
						<button mat-raised-button (click)="cambiarRango('dia')">Al Día</button>&nbsp;
						<button mat-raised-button (click)="cambiarRango('semana')">7 Días</button>&nbsp;
						<button mat-raised-button (click)="cambiarRango('mes')">30 Días</button>&nbsp;
					</div>
					<div class="col-md-12 mt-3">
						<dx-chart id="chart" [dataSource]="alertasHW" [rotated]="true"
							[customizePoint]="customizePointAlertas">
							<dxo-size [height]="350">
							</dxo-size>
							<dxo-common-series-settings argumentField="titulo" type="bar" [valueField]="valueField"
								[ignoreEmptyPoints]="true">
								<dxo-label [visible]="true" color="#ffffff">
									<dxo-connector [visible]="false"></dxo-connector>
								</dxo-label>
							</dxo-common-series-settings>
							<dxo-series-template nameField="titulo"></dxo-series-template>
							<dxo-legend [visible]="false"></dxo-legend>
							<dxi-value-axis>
								<dxo-tick [visible]="false"></dxo-tick>
								<dxo-label [visible]="false"></dxo-label>
							</dxi-value-axis>
							<dxo-tooltip [enabled]="true"></dxo-tooltip>
						</dx-chart>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="{{mostrarAlertas ? 'col-lg-12 col-xl-12 col-sm-12 order-lg-1 order-xl-1' : 'col-lg-12 col-xl-6 col-sm-12 order-lg-1 order-xl-1'}} mt-3"
		*ngxPermissionsOnly="[permisoVisualizarSemaforo]">
		<mat-card class="card_graphic" style="background-color: white;">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-shipping-fast fa-2x" style="color: #46be8a;"></i></div>
				<mat-card-title>Exceso de Velocidad</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<dx-chart (onSeriesClick)="irMonitoreo('azul')" [dataSource]="datosBarras">
					<dxi-series type="bar" name="Population" argumentField="economico" valueField="velocidad"
						color="#2a82ef">
					</dxi-series>
					<dxi-value-axis>
						<dxo-label [customizeText]="valueItems"></dxo-label>
					</dxi-value-axis>
					<dxo-argument-axis>
						<dxo-label [customizeText]="legendItems"></dxo-label>
					</dxo-argument-axis>
					<dxo-common-annotation-settings type="custom" series="Population" template="template"
						[allowDragging]="true">
					</dxo-common-annotation-settings>
					<dxi-annotation *ngFor="let data of datosBarras" [data]="data" [argument]="data.economico">
					</dxi-annotation>
					<dxo-legend [visible]="false"></dxo-legend>
					<svg *dxTemplate="let annotation of 'template'" class="annotation">
						<image attr.href="{{annotation.data.imagen}}" width="60" height="40" />
						<rect x="0" y="0" class="border" />
						<text x="70" y="25" class="state">{{annotation.data.economico}}</text>
						<text x="0" y="60">
							<tspan class="caption">Velocidad:</tspan>
							<tspan class="capital" dx="5">{{annotation.data.velocidad}}</tspan>
							<tspan dx="5">km/h</tspan>

							<tspan dy="14" x="0" class="caption">Marca:</tspan>
							<tspan class="population" dx="5">{{annotation.data.marca}}</tspan>

							<tspan dy="14" x="0" class="caption">Modelo:</tspan>
							<tspan class="area" dx="5">{{annotation.data.modelo}}</tspan>
						</text>
					</svg>
				</dx-chart>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="col-lg-6 col-xl-3 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarTelefonos]">
		<mat-card style="background-color: #acb7bf; cursor: pointer;" (click)="telefonos()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-mobile-alt fa-2x" style="color: #acb7bf;"></i></div>
				<mat-card-title>&nbsp;App Posición</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{totalTelefonos}}<br>
						<small class="arial">Teléfonos</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-mobile-alt fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="col-lg-6 col-xl-3 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarMedidores]">
		<mat-card style="background-color: #2e4095; cursor: pointer;" (click)="medidores()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-dewpoint fa-2x" style="color: #f4f4f569;"></i></div>
				<mat-card-title>&nbsp;Macromedidores</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{totalMedidores}}<br>
						<small class="arial">Macromedidores</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-hand-holding-water fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>


	<div class="col-lg-6 col-xl-3 col-sm-6 order-lg-1 order-xl-1 mt-3" *ngxPermissionsOnly="[permisoVisualizarActivos]">
		<mat-card style="background-color: #ff0000; cursor: pointer;" (click)="activos()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-signal-stream fa-2x" style="color: #ff0000;"></i></div>
				<mat-card-title>&nbsp;Activos</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{totalActivos}}<br>
						<small class="arial">Activos</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-router fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="col-lg-6 col-xl-3 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarMicromedidores]">
		<mat-card style="background-color: #86bff1; cursor: pointer;" (click)="micromedidores()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-weight fa-2x" style="color:#86bff1;"></i></div>
				<mat-card-title>&nbsp;Micromedidores</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{totalMicromedidores}} <br>
						<small class="arial">Micromedidores</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-tachometer-alt-slow fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="col-lg-12 col-xl-6 col-sm-12 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarMedidores]">
		<mat-card class="card-table">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-dewpoint fa-2x"></i></div>
				<mat-card-title>&nbsp;Últimas Mediciones de Macromedidores</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="kt-portlet">
					<div class="kt-portlet__body">
						<div class="kt-section">
							<div class="kt-section__content">
								<div class="contenedor-modal">
									<div class="data-grid">
										<dx-data-grid [dataSource]="ultimimasDatosDataSource" [showBorders]="true"
											[columnHidingEnabled]="true">
											<dxo-paging [pageSize]="5"></dxo-paging>
											<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 30]"
												[showInfo]="true">
											</dxo-pager>
											<dxi-column [width]="150" dataField="descripcion" caption="Descripción"
												alignment="center">
												<dxo-header-filter></dxo-header-filter>
											</dxi-column>
											<dxi-column dataField="imei" caption="Imei" alignment="center">
												<dxo-header-filter></dxo-header-filter>
											</dxi-column>
											<dxi-column dataField="fechaHora" alignment="center"
												caption="Última Transmisión" cellTemplate="dateCell">
												<div *dxTemplate="let cellData of 'dateCell'">
													{{cellData.value | date: 'yyyy-MM-dd h:mma'}}
												</div>
											</dxi-column>
											<dxi-column dataField="gasto" [width]="150" alignment="center"
												caption="Gasto m3/h" cellTemplate="gasCell">
												<div *dxTemplate="let cellData of 'gasCell'">
													{{cellData.value | number: '1.4-4'}}
												</div>
											</dxi-column>
											<dxi-column dataField="totalizador" alignment="center"
												caption="Totalizador m3" cellTemplate="totCell">
												<div *dxTemplate="let cellData of 'totCell'">
													{{cellData.value | number: '1.4-4'}}
												</div>
											</dxi-column>
										</dx-data-grid>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="col-lg-12 col-xl-6 col-sm-12 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarMicromedidores]">
		<mat-card class="card-table">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-weight fa-2x" style="color:#5499C7;"></i></div>
				<mat-card-title>&nbsp;Últimas Mediciones de Micromedidores</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="kt-portlet">
					<div class="kt-portlet__body">
						<div class="kt-section">
							<div class="kt-section__content">
								<div class="contenedor-modal">
									<div class="data-grid">
										<dx-data-grid [dataSource]="ultimasMicromedidores" [showBorders]="true"
											style="margin:0px; width: 100%!important;" [columnHidingEnabled]="true">
											<dxo-paging [pageSize]="5"></dxo-paging>
											<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 30]"
												[showInfo]="true">
											</dxo-pager>
											<dxi-column dataField="numeroSerie" caption="Número de serie"
												alignment="center">
												<dxo-header-filter></dxo-header-filter>
											</dxi-column>
											<dxi-column dataField="fechaHora" alignment="center"
												caption="Última Transmisión" cellTemplate="dateCell">
												<div *dxTemplate="let cellData of 'dateCell'">
													{{cellData.value | date: 'yyyy-MM-dd h:mma'}}
												</div>
											</dxi-column>
											<dxi-column dataField="contador" [width]="150" alignment="center"
												caption="Contador" cellTemplate="gasCell">
												<div *dxTemplate="let cellData of 'gasCell'">
													{{cellData.value | number: '1.4-4'}}
												</div>
											</dxi-column>
											<dxi-column dataField="observacion" [width]="150" caption="Observación"
												alignment="center">
												<dxo-header-filter></dxo-header-filter>
											</dxi-column>
										</dx-data-grid>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
	<div class="col-lg-12 col-xl-6 col-sm-12 order-lg-1 order-xl-1 mt-3" *ngxPermissionsOnly="[permisoVisualizarPortatiles]">
		<mat-card style="background-color: #af60e6; cursor: pointer;" (click)="portatiles()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-tablet-rugged fa-2x" style="color: #af60e6;"></i></div>
				<mat-card-title>&nbsp;Portátiles</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{totalPortatiles}}<br>
						<small class="arial">Portátiles</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-router fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>

</div>


<!--Seccion para Casa Ley-->
<div class="row content-cards" *ngIf="esHW">
	<div class="col-lg-6 col-xl-4 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarVehiculo]">
		<mat-card style="background-color: #3da73d; cursor: pointer;" (click)="irMonitoreo('verde')">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-car-side fa-2x" style="color: #3da73d;"></i></div>
				<mat-card-title>Vehículos en Movimiento</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{vehiculosEnMovimiento}} <br>
						<small class="arial">Vehículos</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-car fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
	<div class="col-lg-6 col-xl-4 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarVehiculo]">
		<mat-card style="background-color: #ff8101; cursor: pointer;" (click)="irAdministracionVehiculos()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-car fa-2x" style="color: #ff8101;"></i></div>
				<mat-card-title>Total de Vehículos</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{totalVehiculos}}<br>
						<small class="arial">Vehículos</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-car-bus fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
	<div class="col-lg-6 col-xl-4 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoAlertaSalidaGeocerca]">
		<mat-card style="background-color: #800180; cursor: pointer;" (click)="alertasHeader()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-map-marker-exclamation fa-2x" style="color: #90458f;"></i></div>
				<mat-card-title>Salidas de Geocerca</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{vehiculosFueraGeocerca}}<br>
						<small class="arial">Vehículos</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-draw-polygon fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
	<div class="col-lg-6 col-xl-4 col-sm-6 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarVehiculo]">
		<mat-card style="background-color: #f9c301; cursor: pointer;" (click)="irAdministracionConsola()">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-exclamation-triangle fa-2x" style="color: #ffc107ad;"></i></div>
				<mat-card-title>&nbsp;Velocidad Alertados</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-6 label">
						{{totalAlertados}}<br>
						<small class="arial">Alertados</small>
					</div>
					<div class="col-md-6">
						<i class="fal fa-engine-warning fa-7x icon"></i>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
	<div class="col-lg-12 col-xl-6 col-sm-12 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoVisualizarSemaforo]">
		<mat-card class="card_graphic" style="background-color: white;">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-file-chart-pie fa-2x" style="color: #46be8a;"></i></div>
				<mat-card-title>Estado en Movimiento</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<dx-pie-chart (onPointClick)="semaforo($event)" type="doughnut" palette="Soft Pastel" [dataSource]="datosPastel"
					[customizePoint]="customizePoint">
					<dxi-series argumentField="etiqueta">
						<dxo-label [visible]="true" [customizeText]="etiquetaPie">
							<dxo-connector [visible]="true"></dxo-connector>
						</dxo-label>
					</dxi-series>
					<dxo-legend [margin]="0" horizontalAlignment="right" verticalAlignment="top"></dxo-legend>
					<dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip">
					</dxo-tooltip>
				</dx-pie-chart>
			</mat-card-content>
		</mat-card>
	</div>
	<div class="col-lg-12 col-xl-6 col-sm-12 order-lg-1 order-xl-1 mt-3"
		*ngxPermissionsOnly="[permisoMostrarAlertasMDVR]">
		<mat-card class="card_graphic" style="background-color: white;">
			<mat-card-header>
				<div mat-card-avatar><i class="fal fa-file-chart-pie fa-2x" style="color: #46be8a;"></i></div>
				<mat-card-title>Alertas</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-md-12">
						<button mat-raised-button (click)="cambiarRango('dia')">Al Día</button>&nbsp;
						<button mat-raised-button (click)="cambiarRango('semana')">7 Días</button>&nbsp;
						<button mat-raised-button (click)="cambiarRango('mes')">30 Días</button>&nbsp;
					</div>
					<div class="col-md-12 mt-3">
						<dx-chart id="chart" [dataSource]="alertasHW" [rotated]="true"
							[customizePoint]="customizePointAlertas">
							<dxo-size [height]="350">
							</dxo-size>
							<dxo-common-series-settings argumentField="titulo" type="bar" [valueField]="valueField"
								[ignoreEmptyPoints]="true">
								<dxo-label [visible]="true" color="#ffffff">
									<dxo-connector [visible]="false"></dxo-connector>
								</dxo-label>
							</dxo-common-series-settings>
							<dxo-series-template nameField="titulo"></dxo-series-template>
							<dxo-legend [visible]="false"></dxo-legend>
							<dxi-value-axis>
								<dxo-tick [visible]="false"></dxo-tick>
								<dxo-label [visible]="false"></dxo-label>
							</dxi-value-axis>
							<dxo-tooltip [enabled]="true"></dxo-tooltip>
						</dx-chart>
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
